import "./ModalGerenciaAnimal.css"

import { logout } from "../../auth"
import { post } from "../../services/api"

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content'

//Import das imagens dos animais
import leaoImagem from '../../assets/img/leao.svg'
import tigreImagem from '../../assets/img/tigre.svg'
import pinguimImagem from '../../assets/img/pinguim.svg'
import girafaImagem from '../../assets/img/girafa.svg'
import hipopotamoImagem from '../../assets/img/hipopotamo.svg'
import zebraImagem from '../../assets/img/zebra.svg'
import jaguarImagem from '../../assets/img/jaguar.svg'
import vacaLeiteiraImagem from '../../assets/img/vaca.svg'
import suricatoImagem from '../../assets/img/suricato.svg'
import { useState } from "react"

function ModalGerenciaAnimal({ metas, mes, ano, authToken, hideModalGerenciaAnimal, refetchMetas, setNotifier }) {
    
    const TIPO_GERENTE = 1;
    const TIPO_VENDEDOR = 2;

    const ID_GIRAFA = 4;
    const ID_HIPOPOTAMO = 6;
    const ID_JAGUAR = 7;
    const ID_SURICATO = 10;
    
    const animalsMap = {
        1: { className: 'leao', icon: leaoImagem },
        2: { className: 'tigre', icon: tigreImagem },
        3: { className: 'pinguim', icon: pinguimImagem },
        4: { className: 'girafa', icon: girafaImagem },
        5: { className: 'zebra', icon: zebraImagem },
        6: { className: 'hipopotamo', icon: hipopotamoImagem },
        7: { className: 'jaguar', icon: jaguarImagem },
        8: { className: 'vaca_leiteira', icon: vacaLeiteiraImagem },
        10: { className: 'suricato', icon: suricatoImagem },
        11: { className: 'zebra_velha', icon: zebraImagem }
    }
    
    const nomeMeses = [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
    ];

    const [ metasInputs, setMetasInputs ] = useState(metas.metas.map(meta => parseFloat(meta.meta || '0').toLocaleString('pt', { minimumFractionDigits: 0, maximumFractionDigits: 2 })))
    const [ pontosInputs, setPontosInputs ] = useState(metas.metas.map(meta => parseInt(meta.pontos || '0').toLocaleString('pt')))

    function isSaveEnabled() {
        const pontosNumber = pontosInputs.map(pontos => pontos === '' ? NaN : Number(pontos.replaceAll('.', '')))
        const metasNumber = metasInputs.map(metas => metas === '' ? NaN : Number(metas.replaceAll('.', '').replace(',', '.')))

        return  pontosNumber.every(pontos => !isNaN(pontos) && pontos >= 0) && 
                metasNumber.every(metas => !isNaN(metas) && metas >= 0)
    } 

    async function handleSubmit(event){
        event.preventDefault()

        const idUsuarioAtual = localStorage.getItem("idusuario")
        if(typeof idUsuarioAtual === 'undefined') {
            logout()
        } else{
            const valores = metas.metas.map((nivel, index) => ({ 
                nivel: nivel.nivel, 
                meta: Number(metasInputs[index].replaceAll('.', '').replace(',', '.')), 
                pontos: Number(pontosInputs[index].replaceAll('.', '').replace(',', '.')) 
            }))

            if(metas.tipo_percentual) {
                const niveisWithError = []
                valores.forEach(valor => {
                    if(valor.meta > 100) {
                        niveisWithError.push(valor.nivel)
                    }
                })

                if(niveisWithError.length > 0){
                    const errorValue = niveisWithError.join(', ')
                    setNotifier(false, `Os niveis ${errorValue} estão incorretos! Este animal é percentual, não pode ter valores acima de 100%`)
                    return
                }
            }

            if(valores.find(valor => valor.meta === 0 || valor.pontos === 0)){
                const confirmarMetasZeradas = await withReactContent(Swal).fire({
                    title: <i>Atenção!</i>,
                    html: 'Existem valores zerados no cadastro. Deseja prosseguir?',
                    showCancelButton: true,
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Não',
                    confirmButtonColor: "green",
                })

                if(!confirmarMetasZeradas.isConfirmed){
                    return;
                }
            }

            const requisicao = {
                idfiliais: [ metas.idfilial ],
                
                id_tipo_metas: metas.id_tipo_metas,
                id_animal: metas.id_animal,
                mes: mes,
                ano: ano,
                idusuario: idUsuarioAtual,

                valores: valores
            }

            try{
                const { response } = await post('/admin/metas', requisicao, authToken);

                if(response?.status === 500){
                    setNotifier(false, response.data.Error)
                }
                else{
                    hideModalGerenciaAnimal()
                    refetchMetas()
                    setNotifier(true, 'Metas alteradas com sucesso')
                }
            } catch (error) {
                if (error.response) {
                    console.error('Erro na resposta do servidor:', error.response.data);
                } else if (error.request) {
                    console.error('Sem resposta do servidor:', error.request);
                } else {
                    console.error('Erro durante a configuração da requisição:', error.message);
                }
            }
            
        }
    }

    function handleInputsChange(index, value, inputsState, setInputsState) {
        const values = [...inputsState] 
        values[index] = value 
        setInputsState(values) 
    };

    function formatValue(input, type) {
        let formattedValue = input.value    

        if(metas.id_animal !== ID_JAGUAR && type === 'meta') {
            formattedValue = formattedValue.replace(/[^\d,]/g, '')
            formattedValue = formattedValue.replace(/(?<!\d),/g, '')
            const firstCommaIndex = formattedValue.indexOf(',');
            formattedValue = formattedValue.replace(/,/g, (match, offset) => {
                return offset === firstCommaIndex ? match : '';
            });
        } else {
            formattedValue = formattedValue.replace(/\D/g, '')
        }

        if(formattedValue === '')
            return formattedValue

        if(metas.id_animal !== ID_JAGUAR && type==='meta'){
            if (metas.tipo_percentual) {
                formattedValue = formattedValue.replace(/[^\d,]/g, '');
            
                if (/^00/.test(formattedValue)) {
                    formattedValue = formattedValue.replace(/^00/, '0');
                }
            
                let numericValue = parseFloat(formattedValue.replace(',', '.'));
            
                if (numericValue > 100) {
                    formattedValue = '100';
                } else {
                    if (formattedValue.includes(',')) {
                        let parts = formattedValue.split(',');
                        formattedValue = parts[0] + ',' + parts[1].slice(0, 2); 
                    }
                }
            } else {
                const firstCommaIndex = formattedValue.indexOf(',');
                let preCommas = parseInt(formattedValue.substring(0, firstCommaIndex === -1 ? formattedValue.length : firstCommaIndex));
                if(preCommas > 999999999)
                    preCommas = 999999999;
                const postCommas = firstCommaIndex === -1 ? '' : formattedValue.substring(firstCommaIndex, firstCommaIndex+3)
                
                formattedValue = preCommas.toLocaleString('pt') + postCommas
            } 
        } else {
            formattedValue = parseInt(formattedValue)
            if(formattedValue > 999999999)
                formattedValue = 999999999;
            formattedValue = formattedValue.toLocaleString('pt')
        }
               
        return formattedValue
    }

    return (
        <>
            <div className="black-background"></div>
            <form onSubmit={handleSubmit} className={`modal-gerencia-animal ${animalsMap[metas.id_animal].className}`}>
                <div className="modal-gerencia-animal-header">
                    <div className="animal-identifier-wrapper">
                        <img src={animalsMap[metas.id_animal].icon} alt={`Imagem do animal ${metas.nome}`} />
                        <h1>{metas.nome}</h1>
                    </div>
                    <div className="animal-filtros-wrapper">
                        <div className="animal-filtros-labels">
                            <label className="label-filiais">Filial</label>
                            <label className="label-periodo">Período</label>
                        </div>
                        <div className="animal-filtros-inputs">
                            <input 
                                type="text" 
                                name="filial"
                                id="filial" 
                                className='input-filial'
                                defaultValue={`${metas.filial_nome} - ${metas.idfilial - 10000}`}
                                readOnly
                            />
                            <input 
                                type="text" 
                                name="mes"
                                id="mes" 
                                className='input-mes'
                                defaultValue={nomeMeses[mes-1]}
                                readOnly
                            />
                            <input 
                                type="number" 
                                name="ano"
                                id="ano" 
                                className='input-ano'
                                defaultValue={ano}
                                readOnly 
                            />
                        </div>
                    </div>
                </div>
                <div className="modal-gerencia-animal-body">
                    {metas.metas.map((meta, index) => 
                        <div className="animal-meta-wrapper" key={index}>
                            <div className="animal-meta-header">
                                <h2>Nível {meta.nivel}</h2>
                            </div>
                            <div className="animal-meta-body">
                                <div className="animal-meta-meta">
                                    <label htmlFor="meta">Meta</label>
                                    <input type="text" value={metasInputs[index]} required
                                    onChange={(event) => { 
                                        const value = formatValue(event.target, 'meta')
                                        handleInputsChange(index, value, metasInputs, setMetasInputs ) 
                                    }}/>
                                </div>
                                <div className="animal-meta-pontos">
                                    <label htmlFor="pontos">Pontos</label>
                                    <input type="text" value={pontosInputs[index]} required
                                    onChange={(event) => { 
                                        const value = formatValue(event.target, 'pontos')
                                        handleInputsChange(index, value, pontosInputs, setPontosInputs) 
                                    }}/>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <div className="modal-gerencia-animal-footer">
                    <button className="animal-cancel-btn" onClick={(event) => {
                        event.preventDefault()

                        hideModalGerenciaAnimal()
                    }}>Cancelar</button>
                    <button className="animal-save-btn" type="submit" disabled={!isSaveEnabled()}>Salvar</button>
                </div>
            </form>
        </>
    )
}

export default ModalGerenciaAnimal